export enum PriceModes {
  PRORATED = 'prorated',
  TIERED = 'tiered'
}